import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { ApplicationApi } from "../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../services/Api/api";
import { SearchSelectApi } from "../../../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	config: Record<string, any>;
}

const AppStocksLinkingForm = ({ form, config }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		watch,
	} = form;
	const [defaultStock, setDefaultStock] = useState<string>(config?.default_stock_name || "");

	const searchStocks = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return api.organization().getStockSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	const handleChangeStock = (stock: SearchSelectApi) => {
		setDefaultStock(stock?.label);
	};

	return (
		<>
			<h5>{t("modules.app.field.stocks_linking.title")}</h5>
			<fieldset>
				<div className="row mb-3">
					<div className="col-md-6">
						<FormSelectGroup
							errors={errors}
							control={control}
							label={t("modules.app.field.default_stock.title")}
							loadOptions={searchStocks}
							onChange={(_, fullObj) => handleChangeStock(fullObj)}
							name="settings.DEFAULT_STOCK_ID"
							getOptionValue={(opt) => opt.id}
							defaultValue={{
								id: watch("settings.DEFAULT_STOCK_ID"),
								label: defaultStock,
							}}
							data-testid="settings.DEFAULT_STOCK_ID"
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
};

export default AppStocksLinkingForm;
